var _g, _g2, _g3, _g4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _g17, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _g18, _path183, _path184, _path185, _path186, _path187;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCapa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 703,
    height: 519,
    viewBox: "0 0 703 519",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.38
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M565.51 330.821L320.81 473.021L31.4902 305.991L276.19 163.781L565.51 330.821Z",
    fill: "#B0F2F7"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M556.271 363.391L320.03 500.681L40.7305 339.421L276.97 202.131L556.271 363.391Z",
    fill: "#B0F2F7"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M577.12 295.12L321.42 443.72L19.0996 269.18L274.81 120.58L577.12 295.12Z",
    fill: "#B0F2F7"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.59
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M232.189 28.9414L232.749 225.401L110.349 296.071L109.789 99.6114L232.189 28.9414Z",
    fill: "#8ABBBF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M232.189 28.9414L232.749 225.401L110.349 296.071L109.789 99.6114L232.189 28.9414Z",
    fill: "#8ABBBF"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M128.889 308.712L128.189 308.302C126.309 307.212 125.189 304.892 125.139 301.592L125.839 302.002C125.839 305.302 127.019 307.622 128.839 308.712",
    fill: "#3E5E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M252.46 33.2904L251.76 32.8804C252.23 32.6053 252.718 32.3614 253.22 32.1504L253.93 32.5604C253.424 32.7713 252.933 33.0152 252.46 33.2904Z",
    fill: "#6091CA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M253.931 32.5605L253.221 32.1505C253.621 31.9823 254.032 31.842 254.451 31.7305L255.161 32.1305C254.741 32.2455 254.33 32.3892 253.931 32.5605Z",
    fill: "#5E8DC5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M255.159 32.1313L254.449 31.7313C254.752 31.6476 255.059 31.5808 255.369 31.5312L256.079 31.9413C255.769 31.9863 255.462 32.0498 255.159 32.1313Z",
    fill: "#5B8AC0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M256.079 31.9412L255.369 31.5312C255.628 31.4907 255.888 31.464 256.149 31.4512L256.859 31.8611C256.598 31.8729 256.337 31.8997 256.079 31.9412Z",
    fill: "#5986BB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M256.86 31.8608L256.15 31.4508C256.38 31.4357 256.611 31.4357 256.84 31.4508L257.55 31.8608C257.321 31.8458 257.09 31.8458 256.86 31.8608Z",
    fill: "#5682B6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M257.55 31.8709L256.84 31.4609C257.051 31.4683 257.262 31.4917 257.47 31.5309L258.18 31.9409C257.972 31.9028 257.761 31.8794 257.55 31.8709Z",
    fill: "#547FB1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M258.181 31.9413L257.471 31.5312C257.671 31.5625 257.868 31.6094 258.061 31.6713L258.771 32.0713C258.571 32.0213 258.381 31.9713 258.181 31.9413Z",
    fill: "#527BAC"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M258.771 32.0699L258.061 31.6699C258.247 31.7227 258.431 31.7861 258.611 31.8599L259.321 32.2699C259.141 32.1899 258.951 32.1299 258.771 32.0699Z",
    fill: "#4F77A7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.319 32.2713L258.609 31.8613C258.791 31.9379 258.968 32.0247 259.139 32.1213L259.839 32.5313C259.671 32.4347 259.498 32.3478 259.319 32.2713Z",
    fill: "#4D74A2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.841 32.5311L259.141 32.1211H259.191L259.901 32.5311H259.841Z",
    fill: "#4A709D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.839 302L125.139 301.59L124.619 118.32L125.319 118.73L125.839 302Z",
    fill: "#406187"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M135.739 100.681L135.029 100.271L251.759 32.8809L252.459 33.2909L135.739 100.681Z",
    fill: "#679CDA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M125.319 118.732L124.619 118.322C124.618 117.636 124.662 116.951 124.749 116.271L125.459 116.681C125.368 117.361 125.322 118.046 125.319 118.732Z",
    fill: "#3E5E84"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M125.46 116.682L124.75 116.272C124.81 115.792 124.9 115.272 125 114.822L125.71 115.232C125.6 115.722 125.52 116.232 125.46 116.682Z",
    fill: "#416289"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M125.71 115.231L125 114.821C125.09 114.421 125.18 114.021 125.3 113.621L126 114.031C125.89 114.431 125.79 114.831 125.71 115.231Z",
    fill: "#43658E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M125.999 114.001L125.299 113.591C125.389 113.231 125.499 112.881 125.619 112.521L126.329 112.931C126.209 113.291 126.099 113.641 125.999 114.001Z",
    fill: "#466993"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M126.329 113.002L125.619 112.592C125.729 112.262 125.849 111.932 125.969 111.592L126.679 112.002C126.549 112.322 126.439 112.652 126.329 113.002Z",
    fill: "#486D98"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M126.679 112.002L125.969 111.592C126.099 111.272 126.219 110.962 126.359 110.652L127.059 111.062C126.929 111.372 126.799 111.682 126.679 112.002Z",
    fill: "#4A709D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M127.059 111.002L126.359 110.592C126.489 110.282 126.629 109.982 126.769 109.682L127.479 110.092C127.329 110.392 127.189 110.692 127.059 111.002Z",
    fill: "#4D74A2"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M127.48 110.132L126.77 109.722L127.22 108.832L127.93 109.242C127.77 109.532 127.62 109.832 127.48 110.132Z",
    fill: "#4F77A7"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M127.929 109.241L127.219 108.831C127.379 108.531 127.549 108.241 127.709 107.951L128.419 108.361C128.249 108.651 128.089 108.941 127.929 109.241Z",
    fill: "#527BAC"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M128.419 108.362L127.709 107.952L128.249 107.072L128.959 107.482C128.769 107.772 128.589 108.062 128.419 108.362Z",
    fill: "#547FB1"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M128.999 107.482L128.289 107.072C128.489 106.762 128.689 106.462 128.899 106.162L129.599 106.572C129.399 106.872 129.189 107.172 128.999 107.482Z",
    fill: "#5682B6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M129.559 106.571L128.859 106.161C129.079 105.841 129.319 105.531 129.559 105.221L130.259 105.631C130.019 105.941 129.789 106.251 129.559 106.571Z",
    fill: "#5986BB"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M130.259 105.631L129.559 105.221C129.829 104.871 130.109 104.521 130.399 104.221L131.109 104.631C130.819 104.961 130.529 105.311 130.259 105.631Z",
    fill: "#5B8AC0"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M131.108 104.601L130.398 104.191C130.768 103.761 131.148 103.361 131.538 102.971L132.248 103.381C131.858 103.771 131.478 104.171 131.108 104.601Z",
    fill: "#5E8DC5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M132.249 103.382L131.539 102.971C132.59 101.931 133.765 101.024 135.039 100.271L135.739 100.681C134.466 101.431 133.294 102.338 132.249 103.382Z",
    fill: "#6091CA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M252.458 33.2903C258.238 29.9503 262.928 32.6303 262.948 39.2903L263.468 222.56C263.468 229.2 258.818 237.28 253.048 240.61L136.328 308C130.558 311.34 125.858 308.66 125.838 302L125.318 118.73C125.318 112.09 129.968 104.01 135.738 100.68L252.458 33.2903Z",
    fill: "#5D8CC4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M152.1 247.702V244.392L240.7 193.232V196.542L152.1 247.702ZM152.1 235.282V232.002L221.98 191.662V194.972L152.1 235.312V235.282ZM152.1 222.892V219.582L239.98 168.852V172.162L152 222.862L152.1 222.892ZM151.6 209.862V206.552L225.43 163.922V167.232L151.6 209.862ZM195.79 135.002V131.702L237.57 107.582V110.882L195.79 135.002ZM195.79 123.422V120.112L231.45 99.5215V102.832L195.8 123.422H195.79ZM151.59 182.522L151.47 138.652L189.65 116.652L189.77 160.512L151.59 182.512V182.522ZM250.83 66.3516L140.58 130.002L141 281.452L251.21 217.832L250.78 66.3615",
    fill: "#F8F6FF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.36 164.922C162.91 165.182 162.55 164.972 162.55 164.462V159.082C162.619 157.806 162.989 156.564 163.628 155.457C164.267 154.351 165.159 153.41 166.23 152.712L175.17 147.552C177.17 146.372 178.87 147.322 178.87 149.662V155.032C178.856 155.313 178.776 155.587 178.635 155.831C178.494 156.075 178.297 156.281 178.06 156.432L163.36 164.922ZM170.68 147.922C168.29 149.302 166.34 148.192 166.33 145.452C166.411 143.955 166.845 142.498 167.596 141.2C168.346 139.902 169.393 138.8 170.65 137.982C173.04 136.602 174.98 137.712 174.99 140.452C174.91 141.949 174.478 143.405 173.729 144.703C172.98 146.001 171.935 147.104 170.68 147.922ZM189.61 116.652L151.43 138.652L151.55 182.522L189.73 160.522L189.61 116.662",
    fill: "#E4E5FD"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M170.65 137.941C169.393 138.759 168.347 139.861 167.596 141.159C166.846 142.457 166.412 143.914 166.33 145.411C166.33 148.151 168.33 149.261 170.68 147.881C171.936 147.063 172.981 145.96 173.729 144.662C174.478 143.364 174.91 141.908 174.99 140.411C174.99 137.671 172.99 136.561 170.65 137.941Z",
    fill: "#A6B3DD"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M175.149 147.552L166.209 152.712C165.138 153.41 164.247 154.35 163.608 155.457C162.968 156.564 162.599 157.806 162.529 159.082V164.462C162.529 164.972 162.889 165.182 163.339 164.922L178.039 156.432C178.276 156.281 178.474 156.074 178.615 155.831C178.756 155.587 178.836 155.313 178.849 155.032V149.662C178.849 147.322 177.189 146.372 175.149 147.552Z",
    fill: "#A6B3DD"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M231.4 99.5215L195.75 120.111L195.76 123.422L231.42 102.831L231.4 99.5215Z",
    fill: "#D3A820"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M237.559 107.582L195.779 131.702L195.789 135.002L237.569 110.882L237.559 107.582Z",
    fill: "#9294AD"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M225.459 163.891L151.619 206.521L151.629 209.831L225.459 167.201V163.891Z",
    fill: "#9294AD"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M239.9 168.822L152.02 219.552L152.03 222.872L239.91 172.132L239.9 168.822Z",
    fill: "#9294AD"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M221.931 191.631L152.051 231.971L152.061 235.281L221.941 194.941L221.931 191.631Z",
    fill: "#9294AD"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M240.69 193.232L152.09 244.392L152.1 247.702L240.7 196.542L240.69 193.232Z",
    fill: "#9294AD"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M194.29 59.9124L193.58 59.5023C194.218 59.1275 194.806 58.6739 195.33 58.1523L196.04 58.5523C195.516 59.0777 194.928 59.5347 194.29 59.9124Z",
    fill: "#6091CA"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M196.001 58.551L195.291 58.151C195.491 57.951 195.681 57.751 195.861 57.541L196.571 57.941C196.381 58.161 196.191 58.361 196.001 58.551Z",
    fill: "#5E8DC5"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M196.61 57.9415L195.9 57.5415C196.05 57.3715 196.19 57.1915 196.33 57.0215L197.03 57.4315C196.9 57.6015 196.75 57.7815 196.61 57.9415Z",
    fill: "#5B8AC0"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M197.001 57.431L196.301 57.021L196.651 56.541L197.351 56.951L197.001 57.431Z",
    fill: "#5986BB"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M197.38 57.0006L196.68 56.5906L196.98 56.1406L197.69 56.5506L197.38 57.0006Z",
    fill: "#5682B6"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M197.69 56.5023L196.98 56.0923C197.08 55.9423 197.17 55.8023 197.25 55.6523L197.96 56.0523L197.69 56.5023Z",
    fill: "#547FB1"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M198.001 56.0511L197.291 55.6512C197.381 55.5012 197.461 55.3512 197.541 55.2012L198.241 55.6111C198.171 55.7611 198.081 55.9111 198.001 56.0511Z",
    fill: "#527BAC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M198.2 55.6117L197.5 55.2017C197.58 55.0617 197.65 54.9117 197.73 54.7617L198.43 55.1717C198.36 55.3217 198.28 55.4717 198.2 55.6117Z",
    fill: "#4F77A7"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M198.43 55.1708L197.73 54.7608C197.8 54.6108 197.87 54.4508 197.93 54.3008L198.64 54.7108L198.43 55.1708Z",
    fill: "#4D74A2"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M198.64 54.712L197.93 54.302C198 54.142 198.07 53.992 198.13 53.832L198.83 54.242C198.77 54.402 198.71 54.552 198.64 54.712Z",
    fill: "#4A709D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M198.831 54.2418L198.131 53.8318C198.191 53.6718 198.251 53.5018 198.301 53.3418L199.011 53.7418C198.951 53.9118 198.901 54.0818 198.831 54.2418Z",
    fill: "#486D98"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.001 53.7408L198.291 53.3408C198.351 53.1608 198.411 52.9808 198.461 52.8008L199.161 53.2108C199.161 53.3908 199.061 53.5708 199.001 53.7408Z",
    fill: "#466993"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M199.171 53.2112L198.471 52.8011L198.621 52.2012L199.321 52.6111C199.281 52.8111 199.231 53.0112 199.171 53.2112Z",
    fill: "#43658E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M199.319 52.6107L198.619 52.2007C198.619 51.9607 198.709 51.7107 198.739 51.4707L199.439 51.8807C199.439 52.1207 199.369 52.3707 199.319 52.6107Z",
    fill: "#416289"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M199.439 51.8816L198.739 51.4716C198.781 51.1398 198.805 50.8059 198.809 50.4716C198.874 49.8249 198.766 49.1726 198.497 48.5809C198.229 47.9891 197.809 47.4788 197.279 47.1016L197.979 47.5116C198.51 47.8874 198.931 48.3974 199.2 48.9896C199.469 49.5817 199.576 50.2347 199.509 50.8816C199.51 51.2161 199.486 51.5503 199.439 51.8816Z",
    fill: "#3E5E84"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M190.55 60.2791L189.85 59.8691L190.56 60.2791",
    fill: "#4A709D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M190.579 60.2909L189.869 59.8809L190.139 60.0109L190.839 60.4209L190.579 60.2909Z",
    fill: "#4D74A2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M190.839 60.4198L190.139 60.0098L190.419 60.1097L191.119 60.5197L190.839 60.4198Z",
    fill: "#4F77A7"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M191.12 60.5194L190.42 60.1094L190.71 60.1794L191.42 60.5894L191.12 60.5194Z",
    fill: "#527BAC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M191.419 60.5897L190.709 60.1797C190.816 60.1851 190.922 60.1851 191.029 60.1797L191.729 60.5897C191.626 60.595 191.522 60.595 191.419 60.5897Z",
    fill: "#547FB1"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M191.729 60.6209L191.029 60.2109H191.379L192.079 60.6209H191.729Z",
    fill: "#5682B6"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M192.079 60.6307L191.379 60.2207H191.769L192.469 60.6307H192.079Z",
    fill: "#5986BB"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M192.47 60.5901L191.77 60.1801L192.23 60.0801L192.93 60.4901L192.47 60.5901Z",
    fill: "#5B8AC0"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M192.93 60.4891L192.23 60.0791L192.85 59.8691L193.55 60.2691C193.349 60.3557 193.142 60.4292 192.93 60.4891Z",
    fill: "#5E8DC5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M193.55 60.27L192.85 59.87C193.1 59.7607 193.344 59.6371 193.58 59.5L194.29 59.91C194.05 60.0441 193.803 60.1643 193.55 60.27Z",
    fill: "#6091CA"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M203.659 31.2803L202.949 30.8703C203.307 30.663 203.678 30.4793 204.059 30.3203L204.769 30.7303C204.386 30.8853 204.015 31.0691 203.659 31.2803Z",
    fill: "#6091CA"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M204.769 30.73L204.059 30.32C204.365 30.194 204.679 30.0871 204.999 30L205.709 30.41C205.392 30.4992 205.081 30.6095 204.779 30.74",
    fill: "#5E8DC5"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M205.7 30.4013L205 30.0013C205.23 29.9412 205.464 29.8945 205.7 29.8613L206.41 30.2713C206.174 30.3045 205.94 30.3513 205.71 30.4113",
    fill: "#5B8AC0"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M206.399 30.261L205.689 29.851C205.884 29.8167 206.082 29.7966 206.279 29.791L206.989 30.201C206.791 30.2015 206.594 30.2216 206.399 30.261Z",
    fill: "#5986BB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M206.999 30.2007L206.289 29.7907C206.466 29.7807 206.643 29.7807 206.819 29.7907L207.519 30.2007H206.999Z",
    fill: "#5682B6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M207.509 30.201L206.809 29.791C206.966 29.8005 207.123 29.8206 207.279 29.851L207.989 30.261L207.509 30.201Z",
    fill: "#547FB1"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M207.999 30.2616L207.289 29.8516C207.441 29.8743 207.592 29.9077 207.739 29.9516L208.439 30.3615C208.295 30.3177 208.148 30.2843 207.999 30.2616Z",
    fill: "#527BAC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M208.429 30.3611L207.729 29.9512L208.149 30.1012L208.849 30.5112C208.713 30.4492 208.573 30.399 208.429 30.3611Z",
    fill: "#4F77A7"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M208.848 30.5116L208.148 30.1016C208.283 30.1548 208.414 30.2183 208.538 30.2916L209.248 30.7016C209.12 30.6282 208.986 30.5647 208.848 30.5116Z",
    fill: "#4D74A2"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M209.249 30.701L208.539 30.291H208.589L209.289 30.701",
    fill: "#4A709D"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M176.539 77.1201L175.839 76.7101L175.779 55.6602L176.489 56.0702L176.539 77.1201Z",
    fill: "#406187"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M184.38 42.4111L183.67 42.0011L202.95 30.8711L203.66 31.2811L184.38 42.4111Z",
    fill: "#679CDA"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M176.479 56.0694L175.779 55.6594C175.779 55.1411 175.812 54.6233 175.879 54.1094L176.589 54.5194C176.519 55.0331 176.482 55.5509 176.479 56.0694Z",
    fill: "#3E5E84"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M176.589 54.5195L175.879 54.1095C175.929 53.7495 175.989 53.3895 176.069 53.0195L176.769 53.4295C176.699 53.7995 176.629 54.1595 176.589 54.5195Z",
    fill: "#416289"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M176.768 53.4294L176.068 53.0194C176.128 52.7194 176.208 52.4094 176.288 52.1094L176.998 52.5194C176.908 52.8194 176.838 53.1294 176.768 53.4294Z",
    fill: "#43658E"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M176.999 52.5205L176.289 52.1105C176.369 51.8405 176.449 51.5705 176.539 51.3105L177.239 51.7206C177.149 51.9806 177.069 52.2505 176.999 52.5205Z",
    fill: "#466993"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M177.239 51.7206L176.539 51.3105C176.619 51.0639 176.709 50.8139 176.809 50.5605L177.509 50.9706C177.409 51.2206 177.329 51.4706 177.239 51.7206Z",
    fill: "#486D98"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M177.509 51.0009L176.809 50.5909C176.899 50.3509 176.989 50.1109 177.099 49.8809L177.799 50.2909C177.699 50.5209 177.599 50.7609 177.509 51.0009Z",
    fill: "#4A709D"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M177.8 50.2602L177.1 49.8502C177.2 49.6202 177.3 49.3902 177.41 49.1602L178.11 49.5702L177.8 50.2602Z",
    fill: "#4D74A2"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M178.11 49.5703L177.41 49.1602C177.52 48.9402 177.63 48.7102 177.75 48.4902L178.46 48.9002L178.11 49.5703Z",
    fill: "#4F77A7"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M178.46 48.9003L177.75 48.4903C177.87 48.2703 177.99 48.0403 178.12 47.8203L178.83 48.2303C178.7 48.4503 178.58 48.6703 178.46 48.9003Z",
    fill: "#527BAC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M178.829 48.2304L178.119 47.8204L178.529 47.1504L179.239 47.5604L178.829 48.2304Z",
    fill: "#547FB1"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M179.239 47.5607L178.529 47.1507C178.679 46.9207 178.829 46.6907 178.989 46.4707L179.689 46.8807C179.539 47.1007 179.379 47.3307 179.239 47.5607Z",
    fill: "#5682B6"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M179.69 46.88L178.99 46.47L179.52 45.75L180.22 46.16L179.69 46.88Z",
    fill: "#5986BB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M180.22 46.1607L179.52 45.7507C179.72 45.4907 179.94 45.2307 180.16 44.9707L180.86 45.3807L180.22 46.1607Z",
    fill: "#5B8AC0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M180.86 45.3808L180.16 44.9708C180.44 44.6508 180.73 44.3408 181.02 44.0508L181.73 44.4608C181.43 44.7508 181.14 45.0608 180.86 45.3808Z",
    fill: "#5E8DC5"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M181.73 44.46L181.02 44.05C181.813 43.2575 182.703 42.5687 183.67 42L184.38 42.41C183.416 42.9632 182.526 43.6351 181.73 44.41",
    fill: "#6091CA"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M203.659 31.2804C208.029 28.7504 211.589 30.7804 211.599 35.8004L211.659 56.8504L176.539 77.1204L176.479 56.0704C176.479 51.0704 179.999 44.9404 184.379 42.4104L203.659 31.2804ZM194.289 59.9104C195.81 58.9194 197.075 57.5832 197.982 56.0105C198.889 54.4379 199.412 52.6733 199.509 50.8604C199.509 47.5304 197.139 46.1904 194.249 47.8604C192.724 48.8506 191.455 50.1878 190.546 51.7625C189.637 53.3372 189.113 55.1046 189.019 56.9204C189.019 60.2404 191.389 61.5804 194.289 59.9204",
    fill: "#5D8CC4"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M124.92 472.751L72.7703 503.061L28.0703 477.251L80.2303 446.951L124.92 472.751Z",
    fill: "#B0F2F7"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M145.41 470.83L106.64 493.36L73.4199 474.18L112.19 451.65L145.41 470.83Z",
    fill: "#B0F2F7"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.68
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M54.54 155.252L25.44 172.162L0.5 157.772L29.6 140.852L54.54 155.252Z",
    fill: "#B0F2F7"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.46
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.46,
    d: "M63.5301 180.611L42.6901 192.721L24.8301 182.411L45.6701 170.301L63.5301 180.611Z",
    fill: "#B0F2F7"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M81.3599 155.481L46.1199 175.961L15.9199 158.521L51.1599 138.041L81.3599 155.481Z",
    fill: "#B0F2F7"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.88
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.88,
    d: "M702.67 369.57L672.86 386.89L647.32 372.15L677.13 354.82L702.67 369.57Z",
    fill: "#B0F2F7"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.66
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.66,
    d: "M491.76 169.89L469.4 182.88L450.25 171.82L472.6 158.83L491.76 169.89Z",
    fill: "#B0F2F7"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.9,
    d: "M265.99 502.651L237.99 518.921L214.01 505.071L242.01 488.801L265.99 502.651Z",
    fill: "#B0F2F7"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.48,
    d: "M660.041 233.441L628.851 251.571L591.961 230.271L623.151 212.141L660.041 233.441Z",
    fill: "#B0F2F7"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.82
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.82,
    d: "M667.389 208.92L626.709 232.56L578.609 204.79L619.289 181.16L667.389 208.92Z",
    fill: "#B0F2F7"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M590.75 479.751L538.6 510.061L493.9 484.251L546.06 453.951L590.75 479.751Z",
    fill: "#B0F2F7"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M545.4 477.821L506.64 500.351L473.42 481.171L512.18 458.641L545.4 477.821Z",
    fill: "#B0F2F7"
  }))), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1094 25.5312L80.8894 41.5212",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6602 36.541L86.4702 30.4609",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M115.96 16.4707L112.1 26.5007",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M108.789 19.4707L119.339 23.5307",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9395 1.4707L98.1395 7.55069",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M93.8691 5.65985L100.259 3.33984",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M590.71 96.1504L579.32 108.77",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M578.43 96.5098L591.7 108.49",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M619.109 85.4902L622.939 95.5403",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M615.779 92.5204L626.339 88.4805",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M639.109 466.49L642.939 476.54",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M635.779 473.521L646.339 469.48",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M660.131 452.102L661.971 456.922",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M658.529 455.471L663.599 453.531",
    stroke: "white",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M632.991 432.26L623.051 444.67",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M621.539 433.271L634.589 443.731",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M602.939 70.4707L605.139 76.5507",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M600.869 74.6599L607.259 72.3398",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.51
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M457.99 332.921L319.14 413.611L216.02 354.071L354.86 273.381L457.99 332.921Z",
    fill: "#91C0C2"
  }))), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M446.079 315.539L446.039 327.769L319.879 401.079L319.919 388.849L446.079 315.539Z",
    fill: "#CDC6C9"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M319.92 388.85L319.88 401.08L227.01 347.46L227.04 335.24L319.92 388.85Z",
    fill: "#A19A9C"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M446.079 315.54L319.919 388.85L227.039 335.24L353.199 261.92L446.079 315.54Z",
    fill: "#DDD6DA"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M390.561 331.57L390.551 335.64L378.381 342.71L378.401 338.64L390.561 331.57Z",
    fill: "#1B7593"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M378.401 338.641L378.381 342.711L366.061 335.601L366.071 331.521L378.401 338.641Z",
    fill: "#135266"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M390.56 331.571L378.4 338.641L366.07 331.521L378.24 324.451L390.56 331.571Z",
    fill: "#1E83A5"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M373.632 341.869L373.622 345.949L361.012 353.279L361.022 349.199L373.632 341.869Z",
    fill: "#1B7593"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M361.021 349.2L361.011 353.28L347.961 345.74L347.971 341.67L361.021 349.2Z",
    fill: "#135266"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M373.631 341.87L361.021 349.2L347.971 341.67L360.581 334.34L373.631 341.87Z",
    fill: "#1E83A5"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M354.761 353.221L354.751 357.291L341.711 364.871L341.731 360.791L354.761 353.221Z",
    fill: "#1B7593"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M341.73 360.792L341.71 364.872L328.24 357.092L328.25 353.012L341.73 360.792Z",
    fill: "#135266"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M354.76 353.221L341.73 360.791L328.25 353.011L341.28 345.441L354.76 353.221Z",
    fill: "#1E83A5"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M335.659 364.07L335.649 368.15L322.109 376.01L322.119 371.94L335.659 364.07Z",
    fill: "#1B7593"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M322.12 371.94L322.11 376.01L308.49 368.15L308.5 364.07L322.12 371.94Z",
    fill: "#135266"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M335.66 364.071L322.12 371.941L308.5 364.071L322.03 356.211L335.66 364.071Z",
    fill: "#1E83A5"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M369.561 319.57L369.551 323.65L357.391 330.72L357.401 326.64L369.561 319.57Z",
    fill: "#2B3133"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M357.401 326.641L357.391 330.721L345.061 323.601L345.081 319.531L357.401 326.641Z",
    fill: "#1E2223"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M369.56 319.571L357.4 326.641L345.08 319.531L357.24 312.461L369.56 319.571Z",
    fill: "#303739"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M352.64 329.869L352.63 333.949L340.01 341.279L340.02 337.199L352.64 329.869Z",
    fill: "#2B3133"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M340.019 337.2L340.009 341.28L326.949 333.74L326.969 329.66L340.019 337.2Z",
    fill: "#1E2223"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M352.639 329.87L340.019 337.2L326.969 329.66L339.579 322.33L352.639 329.87Z",
    fill: "#303739"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M333.761 341.221L333.751 345.301L320.721 352.871L320.731 348.801L333.761 341.221Z",
    fill: "#2B3133"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M320.73 348.802L320.72 352.872L307.24 345.092L307.25 341.012L320.73 348.802Z",
    fill: "#1E2223"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M333.76 341.221L320.73 348.801L307.25 341.011L320.29 333.441L333.76 341.221Z",
    fill: "#303739"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M314.649 352.061L314.639 356.141L301.109 364.011L301.119 359.931L314.649 352.061Z",
    fill: "#AB4C4C"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M301.12 359.93L301.11 364.01L287.49 356.14L287.5 352.07L301.12 359.93Z",
    fill: "#773535"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M314.65 352.061L301.12 359.931L287.5 352.071L301.03 344.201L314.65 352.061Z",
    fill: "#BE5454"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M349.571 307.57L349.561 311.64L337.391 318.71L337.401 314.63L349.571 307.57Z",
    fill: "#2B3133"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M337.4 314.631L337.39 318.711L325.07 311.601L325.08 307.521L337.4 314.631Z",
    fill: "#1E2223"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M349.57 307.571L337.4 314.631L325.08 307.521L337.25 300.451L349.57 307.571Z",
    fill: "#303739"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M332.642 317.879L332.632 321.949L320.012 329.279L320.022 325.209L332.642 317.879Z",
    fill: "#2B3133"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M320.021 325.21L320.011 329.28L306.961 321.74L306.971 317.67L320.021 325.21Z",
    fill: "#1E2223"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M332.641 317.88L320.021 325.21L306.971 317.67L319.581 310.34L332.641 317.88Z",
    fill: "#303739"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M313.771 329.221L313.761 333.291L300.711 340.871L300.731 336.801L313.771 329.221Z",
    fill: "#2B3133"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M300.73 336.802L300.71 340.872L287.24 333.092L287.25 329.012L300.73 336.802Z",
    fill: "#1E2223"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M313.77 329.221L300.73 336.801L287.25 329.011L300.29 321.441L313.77 329.221Z",
    fill: "#303739"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M294.651 340.07L294.641 344.14L281.111 352.01L281.121 347.93L294.651 340.07Z",
    fill: "#2B3133"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M281.12 347.93L281.11 352.01L267.48 344.14L267.49 340.07L281.12 347.93Z",
    fill: "#1E2223"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M294.65 340.071L281.12 347.931L267.49 340.071L281.03 332.201L294.65 340.071Z",
    fill: "#303739"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M330.571 296.57L330.561 300.64L318.391 307.71L318.401 303.64L330.571 296.57Z",
    fill: "#2B3133"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M318.4 303.641L318.39 307.711L306.07 300.601L306.08 296.521L318.4 303.641Z",
    fill: "#1E2223"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M330.57 296.571L318.4 303.641L306.08 296.521L318.25 289.451L330.57 296.571Z",
    fill: "#303739"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M313.642 306.869L313.632 310.949L301.021 318.279L301.031 314.199L313.642 306.869Z",
    fill: "#2B3133"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M301.031 314.2L301.021 318.28L287.961 310.74L287.971 306.66L301.031 314.2Z",
    fill: "#1E2223"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M313.641 306.87L301.031 314.2L287.971 306.66L300.581 299.34L313.641 306.87Z",
    fill: "#303739"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M294.771 318.221L294.761 322.291L281.721 329.871L281.731 325.801L294.771 318.221Z",
    fill: "#2B3133"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M281.73 325.801L281.72 329.871L268.24 322.091L268.25 318.021L281.73 325.801Z",
    fill: "#1E2223"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M294.77 318.221L281.73 325.801L268.25 318.021L281.29 310.441L294.77 318.221Z",
    fill: "#303739"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M275.651 329.07L275.641 333.15L262.111 341.01L262.121 336.94L275.651 329.07Z",
    fill: "#2B3133"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M262.12 336.94L262.11 341.01L248.48 333.15L248.49 329.07L262.12 336.94Z",
    fill: "#1E2223"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M275.65 329.071L262.12 336.941L248.49 329.071L262.03 321.211L275.65 329.071Z",
    fill: "#303739"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M328.539 287.89L328.549 285.45L352.129 271.74L352.119 274.19L328.539 287.89Z",
    fill: "#799370"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M352.119 274.19L352.129 271.74L421.139 311.59L421.129 314.03L352.119 274.19Z",
    fill: "#77906E"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M421.129 314.029L397.559 327.739L328.539 287.889L352.119 274.189L421.129 314.029Z",
    fill: "#95BB88"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M324.019 295.781L323.349 296.171L313.249 298.241L312.199 297.631L322.089 295.671L322.119 295.651L318.429 293.521L319.259 293.041L324.019 295.781Z",
    fill: "#DCDCDC"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M301.55 308.101L302.6 308.701L301.81 309.161L300.75 308.561L298.75 309.741L297.75 309.191L299.75 308.001L296.25 306.001L296.92 305.611L305.06 304.781L306.16 305.411L301.55 308.101ZM303.08 306.101C303.48 305.871 303.88 305.651 304.29 305.441C303.62 305.571 303.11 305.651 302.56 305.721L298.17 306.141L300.63 307.561L303.13 306.111",
    fill: "#DCDCDC"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M286.089 316.131L278.609 320.481L277.619 319.911L284.159 316.111L284.139 316.101L282.129 315.751L282.699 315.191L285.219 315.631L286.089 316.131Z",
    fill: "#DCDCDC"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M265.741 326.372C267.331 327.282 266.831 328.632 264.451 330.012C261.901 331.492 259.551 331.762 257.881 330.792C256.411 329.942 256.771 328.572 259.231 327.122C261.691 325.672 264.221 325.492 265.741 326.372ZM258.741 330.372C259.791 330.972 261.501 330.562 263.411 329.452C265.321 328.342 265.981 327.402 264.931 326.792C264.031 326.272 262.311 326.532 260.271 327.722C258.231 328.912 257.821 329.842 258.741 330.372Z",
    fill: "#DCDCDC"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M282.171 339.62C282.581 339.86 282.551 340.19 282.121 340.44C281.904 340.561 281.659 340.624 281.411 340.624C281.162 340.624 280.918 340.561 280.701 340.44C280.301 340.21 280.331 339.86 280.701 339.63C280.924 339.501 281.177 339.431 281.435 339.43C281.692 339.428 281.946 339.494 282.171 339.62Z",
    fill: "#DCDCDC"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M297.02 350.63L297.71 350.23L303.69 353.68L303 354.081L297.02 350.63Z",
    fill: "#DCDCDC"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M299.969 348.91L305.949 352.37L305.259 352.77L299.279 349.32L299.969 348.91Z",
    fill: "#DCDCDC"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M304.471 326.23C306.091 327.16 305.671 328.23 304.591 328.82C303.211 329.63 301.091 329.69 297.971 329.66H296.821L300.201 331.66L299.361 332.151L294.561 329.37L295.181 329.01H296.741C300.491 329.01 302.321 329.01 303.471 328.35C304.231 327.91 304.551 327.291 303.471 326.641C302.776 326.285 302.01 326.094 301.231 326.081L301.631 325.48C302.622 325.512 303.593 325.768 304.471 326.23Z",
    fill: "#DCDCDC"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M324.401 338.281C325.891 339.141 325.681 340.031 324.771 340.561C323.787 341.045 322.652 341.124 321.611 340.781C321.797 340.902 321.946 341.073 322.039 341.274C322.133 341.476 322.167 341.7 322.139 341.921C322.111 342.141 322.021 342.349 321.88 342.521C321.738 342.692 321.552 342.821 321.341 342.891C320.551 343.27 319.679 343.443 318.805 343.394C317.93 343.345 317.083 343.075 316.341 342.611C315.722 342.294 315.215 341.795 314.891 341.181L315.961 340.881C316.215 341.411 316.632 341.845 317.151 342.121C317.619 342.42 318.157 342.59 318.712 342.615C319.267 342.639 319.818 342.517 320.311 342.261C321.311 341.651 320.841 340.841 319.851 340.261L319.291 339.931L320.051 339.491L320.621 339.821C321.059 340.09 321.555 340.251 322.068 340.291C322.581 340.331 323.096 340.249 323.571 340.051C324.171 339.711 324.321 339.171 323.371 338.631C322.749 338.307 322.069 338.11 321.371 338.051L321.841 337.471C322.739 337.568 323.61 337.843 324.401 338.281Z",
    fill: "#DCDCDC"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M325.62 362.411L322.6 364.161L325.67 365.931L324.9 366.381L321.83 364.611L318.8 366.371L317.93 365.871L320.97 364.111L317.9 362.341L318.67 361.891L321.73 363.661L324.75 361.901L325.62 362.411Z",
    fill: "#DCDCDC"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M345.579 355.001L344.609 355.561L337.449 351.431L338.419 350.871L345.579 355.001Z",
    fill: "#DCDCDC"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M325.6 316.721L324.75 317.221L321.88 315.561L319.66 316.561C319.86 316.651 320.04 316.731 320.33 316.891C320.842 317.151 321.264 317.558 321.54 318.061C321.8 318.591 321.64 319.251 320.7 319.801C319.863 320.222 318.934 320.429 317.997 320.405C317.061 320.381 316.144 320.125 315.33 319.661C314.73 319.371 314.236 318.899 313.92 318.311L314.92 318.011C315.199 318.511 315.616 318.921 316.12 319.191C316.639 319.482 317.221 319.642 317.815 319.656C318.409 319.67 318.998 319.538 319.53 319.271C320.48 318.701 320.53 317.931 319.02 317.061C318.657 316.855 318.283 316.668 317.9 316.501L321.97 314.691L325.6 316.721Z",
    fill: "#DCDCDC"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M341.319 329.08C342.659 329.85 342.639 330.94 341.169 331.8C340.385 332.229 339.508 332.461 338.614 332.475C337.72 332.489 336.836 332.284 336.039 331.88C334.419 330.95 334.609 329.62 336.559 328.49C337.976 327.682 339.579 327.258 341.209 327.26C342.419 327.264 343.614 327.519 344.719 328.01C344.997 328.127 345.267 328.261 345.529 328.41L344.699 328.89L344.539 328.79C344.359 328.69 344.139 328.58 343.889 328.47C342.194 327.778 340.295 327.778 338.599 328.47C339.547 328.39 340.496 328.603 341.319 329.08ZM336.819 331.43C337.336 331.672 337.905 331.78 338.475 331.745C339.044 331.71 339.596 331.533 340.079 331.23C341.149 330.61 341.189 329.88 340.249 329.34C339.512 328.975 338.675 328.866 337.869 329.03C337.669 329.057 337.476 329.121 337.299 329.22C336.089 329.95 335.749 330.81 336.819 331.43Z",
    fill: "#DCDCDC"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M367.35 341.431L361.96 341.821L361.2 345.071L360 344.401L360.37 343.021C360.457 342.605 360.567 342.195 360.7 341.791C360.12 341.871 359.57 341.931 358.62 342.021L356.31 342.261L355.16 341.601L360.69 341.151L361.46 338.041L362.63 338.721L362.2 340.161C362.112 340.5 362.005 340.834 361.88 341.161C362.47 341.081 362.95 341.031 363.63 340.961L366.16 340.731L367.35 341.431Z",
    fill: "#DCDCDC"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M339.069 308.001C339.213 308.143 339.319 308.32 339.378 308.514C339.436 308.707 339.446 308.913 339.405 309.111C339.364 309.31 339.275 309.495 339.144 309.65C339.014 309.806 338.848 309.926 338.659 310.001C337.911 310.354 337.088 310.519 336.262 310.481C335.435 310.442 334.631 310.202 333.919 309.781C332.349 308.871 332.329 307.781 333.419 307.141C334.505 306.6 335.757 306.493 336.919 306.841C336.821 306.705 336.754 306.549 336.726 306.384C336.697 306.219 336.707 306.05 336.754 305.89C336.802 305.729 336.885 305.582 336.999 305.459C337.113 305.336 337.253 305.241 337.409 305.181C338.089 304.852 338.839 304.698 339.593 304.731C340.347 304.764 341.081 304.984 341.729 305.371C343.189 306.211 343.019 307.161 342.089 307.701C341.161 308.169 340.092 308.276 339.089 308.001H339.069ZM334.679 309.381C335.109 309.631 335.595 309.77 336.093 309.786C336.59 309.802 337.084 309.693 337.529 309.471C338.439 308.941 338.229 308.321 337.529 307.561C337.062 307.381 336.562 307.299 336.062 307.32C335.561 307.34 335.07 307.463 334.619 307.681C333.829 308.101 333.739 308.821 334.699 309.381H334.679ZM338.479 305.671C337.729 306.111 337.899 306.671 338.539 307.311C339.358 307.594 340.254 307.547 341.039 307.181C341.639 306.831 341.909 306.261 341.039 305.731C340.659 305.513 340.23 305.394 339.792 305.383C339.354 305.373 338.92 305.471 338.529 305.671",
    fill: "#DCDCDC"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M360.77 317.35C362.3 318.24 362.01 319.51 360.1 320.63C358.638 321.477 356.979 321.922 355.29 321.92C354.187 321.913 353.097 321.678 352.09 321.23C351.77 321.09 351.49 320.95 351.27 320.83L351.1 320.72L351.92 320.24L352.1 320.36C352.28 320.46 352.51 320.57 352.79 320.7C353.517 321.012 354.298 321.179 355.09 321.19C356.12 321.213 357.144 321.011 358.09 320.6C357.194 320.664 356.298 320.47 355.51 320.04C354.16 319.26 354.3 318.16 355.58 317.42C356.377 316.996 357.263 316.769 358.166 316.756C359.069 316.744 359.961 316.948 360.77 317.35ZM358.77 320.12C358.932 320.097 359.088 320.043 359.23 319.96C360.51 319.21 361.02 318.37 359.95 317.76C359.425 317.517 358.848 317.407 358.271 317.44C357.693 317.473 357.133 317.648 356.64 317.95C355.71 318.5 355.64 319.2 356.5 319.71C357.191 320.093 357.988 320.237 358.77 320.12Z",
    fill: "#DCDCDC"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M406.499 310.511C409.499 312.221 408.499 314.721 404.079 317.321C399.319 320.081 394.909 320.581 391.789 318.781C389.039 317.191 389.789 314.631 394.319 311.911C398.849 309.191 403.639 308.861 406.499 310.511ZM393.369 318.001C395.319 319.121 398.509 318.351 402.079 316.281C405.649 314.211 406.899 312.451 404.929 311.281C403.259 310.281 400.019 310.791 396.209 313.001C392.569 315.121 391.639 317.001 393.369 318.001Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M383.62 330.36L372.03 333.33L371.25 332.89L382.83 329.9L383.62 330.36Z",
    fill: "#DCDCDC"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.58
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.58,
    d: "M426.041 182.041L425.841 252.961L366.961 218.961L367.161 148.051L426.041 182.041Z",
    fill: "#B2F2F7"
  }))), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M407.231 191.312L415.691 186.402L415.481 257.322L407.031 262.232L407.231 191.312Z",
    fill: "#307B9A"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M345.51 155.681L353.97 150.771L415.69 186.401L407.23 191.311L345.51 155.681Z",
    fill: "#307896"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M407.231 191.312L407.031 262.232L345.311 226.602L345.511 155.682L407.231 191.312Z",
    fill: "#2BA0D2"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M376.7 193.391C373.51 191.551 370.93 193.031 370.92 196.691C371.023 198.685 371.597 200.626 372.594 202.355C373.592 204.085 374.985 205.553 376.66 206.641C379.84 208.481 382.43 207.001 382.44 203.341C382.342 201.339 381.77 199.389 380.772 197.65C379.775 195.912 378.379 194.435 376.7 193.341",
    fill: "white"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M377.5 210.13L375.81 209.13C370.27 205.93 365.76 208.5 365.74 214.87C365.781 215.632 366.001 216.374 366.383 217.035C366.766 217.695 367.299 218.256 367.94 218.67L385.28 228.67C386.5 229.38 387.49 228.81 387.49 227.42C387.49 221.05 383.04 213.3 377.49 210.1",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapa);
export default __webpack_public_path__ + "static/media/capa.c09f423ca8684eff3594dd79bb9d8f63.svg";
export { ForwardRef as ReactComponent };